import { useCallback, useEffect, useState } from "react";

import { PharmacyOrdersClient } from "../Api/PharmacyOrdersClient";
import { PharmacyOrderModel } from "../Models/PharmacyOrderModel";
import { PharmacyOrdersFilterSettingsModel } from "../Models/PharmacyOrdersFilterSettingsModel";
import { PharmacyOrdersTableSettingsModel } from "../Models/PharmacyOrdersTableSettingsModel";

interface IUsePharmacyOrdersTableDataResponse {
    data: PharmacyOrderModel[];
    totalCount: number;
    fetchPharmacyOrders: () => Promise<void>;
}

function usePharmacyOrdersTableData(
    filterSetting: PharmacyOrdersFilterSettingsModel,
    tableSetting: PharmacyOrdersTableSettingsModel
): IUsePharmacyOrdersTableDataResponse {
    const [data, setData] = useState<PharmacyOrderModel[]>([]);
    const [totalCount, setTotalCount] = useState(0);

    const fetchPharmacyOrders = useCallback(
        async (): Promise<void> => {
            const response = await PharmacyOrdersClient.fetchPharmacyOrders({
                FilterSettings: PharmacyOrdersFilterSettingsModel.toResponseModel(filterSetting),
                QueryCurrentPageNumber: tableSetting.currentPageNumber,
                QueryOrderDirection: tableSetting.queryOrderDirection,
                QueryOrderType: tableSetting.queryOrderType,
                SearchText: tableSetting.searchText
            });

            if (response) {
                setData(response.PharmacyOrders.map(p => PharmacyOrderModel.fromResponseModel(p)));
                setTotalCount(response.QueryRowCount);
            }
            else {
                setData([]);
                setTotalCount(0);
            }
        },
        [tableSetting, filterSetting]
    );

    useEffect(
        () => {
            fetchPharmacyOrders();
        },
        [fetchPharmacyOrders]
    );

    return { data, totalCount, fetchPharmacyOrders };
}

export { usePharmacyOrdersTableData };
